<div class="container-fluid">
    <div class="row manageaccount mt-3">
        <div class="col-md-12 my-auto    ">
            <div class="d-flex align-items-baseline justify-content-between">
                <h1 class="fs-4 fw-bold mb-0">Edit Vehicle Maintenance</h1>
                <button class="btn btn-dark btn-sm " mat-raised-button matTooltip="Back" matTooltipPosition="left" (click)="backTo()"><i
                        class="fa-solid fa-arrow-left"></i></button>
            </div>
            <nav class="breadcrumbMaine" aria-label="breadcrumb mb-0">
                <ol class="breadcrumb mb-0">
                    <li class="breadcrumb-item">Miscellaneous expenses</li>
                    <li class="breadcrumb-item" (click)="backTo()">Vehicle Maintenance</li>

                    <li class="breadcrumb-item active" aria-current="page">Edit  Vehicle Maintenance </li>

                </ol>
            </nav>
        </div>

    </div>

    <div class="row mt-3">
        <div class="col-xl-12">
            <form [formGroup]="editVehicleMaintenanceForm" (ngSubmit)="updateVehicleMaintenance()"
                enctype="multipart/form-data">
                <div class="contentbox">
                <div class="row account mb-3">

                    <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                        <div class="form-group accountsinp  mb-3">
                            <label for="">Supervisor Name</label>
                            <select id="supervisornamectrl" formControlName="supervisorname" placeholder="Select Status"
                                class="form-control shadow-none">
                                <option disabled value='null'>--Select Supervisor Name--</option>
                                <option *ngFor="let s of superVisor" value="{{s._id}}">{{s.full_name}}</option>
                            </select>
                        </div>
                    </div> 
                   
                    <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                        <div class="form-group accountsinp  mb-3">

                            <label for="">Expense Category</label>
                            <select id="expenseCategoryctrl" formControlName="expenseCategory"
                                class="form-control shadow-none" placeholder="--Select Expense Category--">
                                <!-- <option disabled value="" default hidden>--Select Expense Category--</option> -->
                                <option *ngFor="let cat of subCat" value={{cat._id}}>{{cat.expenseSubCategory}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                        <div class="form-group accountsinp  mb-3">
                            <label for="">Company Name</label>
                            <select id="companyNameCtrl" formControlName="companyname" class="form-control shadow-none">
                                <option disabled value="">--Select Company Name--</option>
                                <option *ngFor="let c of company" value="{{c._id}}">{{c.clientName}}</option>
                            </select>
                        </div>
                    </div> 
                   
                   
                    
                    <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                        <div class="form-group accountsinp  mb-3">

                            <label for="">Expense Amount</label>
                            <input type="number" id="expenseAmountctrl" class="form-control shadow-none"
                                placeholder="Enter Expense Amount " formControlName="expenseAmount">
                        </div>
                    </div>
                    <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                        <div class="form-group accountsinp  mb-3">

                            <label for="">Expense Date</label>
                            <input type="date" id="expenseDatectrl" class="form-control shadow-none"
                                 formControlName="expenseDate">
                        </div>
                    </div>
                    
                    
                    
                    
                    <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                        <div class="form-group accountsinp  mb-3">

                            <label for="">Expense Description</label>
                            <input type="text" id="expenseDescriptionctrl" class="form-control shadow-none"
                                placeholder="Enter Expense Description " formControlName="expenseDescription">
                        </div>
                    </div>

                    <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                        <div class="form-group accountsinp  mb-3">

                            <label for="">Vehicle Number</label>
                            <input type="text" id="vehicleNumberctrl" class="form-control shadow-none"
                                placeholder="Enter Vehicle Number" formControlName="vehicleNumber">
                        </div>
                    </div>
                    <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                        <div class="form-group accountsinp  mb-3">
                            <label for="">Vehicle Type</label>
                            <select id="vehicleTypectrl" formControlName="vehicleType" placeholder="Select Vehicle Type"
                                class="form-control shadow-none">
                                <option disabled value="">--Select Vehicle Type--</option>
                                <option *ngFor="let c of vehicletypes" value="{{c.vehicletype_name}}">
                                    {{c.vehicletype_name}}</option>

                            </select>

                        </div>
                    </div>
                    <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                        <div class="form-group accountsinp  mb-3">

                            <label for="">Other Charges</label>
                            <input type="text" id="otherChargesctrl" class="form-control shadow-none"
                                placeholder="Enter Other Charges" formControlName="otherCharges">
                        </div>
                    </div>
                    <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                        <div class="form-group accountsinp  mb-3">

                            <label for="">Mechanic Name</label>
                            <input type="text" id="mechanicNamectrl" class="form-control shadow-none"
                                placeholder="Enter Mechanic Name " formControlName="mechanicName">
                        </div>
                    </div>
                    <div class="col-lg-3 col-xl-3 col-sm-6 col-12 col-md-4">
                        <div class="form-group accountsinp  mb-3">

                            <label for="">Mechanic Number</label>
                            <input type="text" id="mechanicNumberctrl" class="form-control shadow-none"
                                placeholder="Enter Mechanic Number " formControlName="mechanicNumber">
                        </div>
                    </div>
                    <!-- <div class="col-lg-4 col-md-6 col-sm-6">
                       
                        <div class="form-group accountsinp  mb-3">
                            <label for="">Attachment</label>
                            <div class="d-flex align-items-center justify-content-between">
                            
                            <input type="file" accept="image/*,.pdf,.doc" id="LRReceipt1ctrl"
                                (change)="fileChangeEventattachReceipt1($event)" class="form-control shadow-none w-auto"
                                formControlName="LRReceipt1">
                            <button class="btn btn-dark btn-sm  px-4 ms-3" type="button" (click)="preview()" mat-raised-button >Preview</button>
                            <a #showSlip [href]="slipURL" target="_blank"></a>
                            </div>

                        </div>

                    </div> -->

                    <div class="col-xl-12 mb-3">
                        <div class="detailsBox">
                            <h4>Upload Document</h4>
                            <div class="row">
                                <div class="col-lg-2 col-xl-2 col-sm-6 col-12 col-md-4">
                                    <div class="form-group accountsinp  mb-3">
                                        <label for="">Vehicle Attachments</label>
                                        <input type="file" accept="image/*,.pdf,.doc" (change)="fileChangeEventattachReceipt1($event)"
                                        id="LRReceipt1ctrl" class="form-control shadow-none d-none" formControlName="LRReceipt1">
                                        <label class="uploadimgNewDesign" for="LRReceipt1ctrl"  *ngIf="!Attachments">
                                            <img src="../../../../assets/images/svg/uploadImageNew.svg" />
                                            <h5>Upload Expense Attachments</h5>
                                        </label>
                                        <div class="viewImage" *ngIf="Attachments">
                                            <div class="imgBoxp">
                                                <button class="resetImg" (click)="resetimg('attechment')"><i class="fa-solid fa-xmark"></i></button>
                                                <img [id]="Attachments" onClick="viewImages(this, 'Vehicle Attachments')" [src]="Attachments" alt="Vehicle Attachments" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 text-end">
                        <button class="btn btn-outline-dark" type="button" (click)="resetForm()"
                        mat-raised-button>Reset</button>
                        <button class="btn btn-dark ms-2" type="submit" mat-raised-button>Update
                        </button>
                    </div>
                </div>
            </div>
            </form>
        </div>
    </div>
</div>

